<template>
  <v-tabs v-model="tab" icons-and-text>
    <v-tabs-slider color="purple darken-4"></v-tabs-slider>
    <v-tab v-for="(tab, i) in tabs" :key="i">
      <v-icon large>{{ tab.icon }}</v-icon>
      <div class="caption py-1">{{ tab.name }}</div>
    </v-tab>
    <v-tab-item>
      <auction-feed />
    </v-tab-item>
    <v-tab-item>
      <inventory />
    </v-tab-item>
  </v-tabs>
</template>
<script>
import AuctionFeed from '@/components/Home/Tabs/AuctionFeed'
import Inventory from '@/components/Home/Tabs/Inventory'

export default {
  name: 'HomeTabs',
  components: {
    AuctionFeed,
    Inventory
  },
  computed: {
    tabs () {
      return [
        { name: this.$t('auction_feed'), icon: 'mdi-store' },
        { name: this.$t('inventory'), icon: 'mdi-home-automation' }
      ]
    }
  },
  data: () => ({
    tab: 0
  })
}
</script>
